import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatWeBuy from "@/pages/WhatWeBuy";
import Development from "@/pages/Development";
import InvestmentOpportunities from "@/pages/InvestmentOpportunities";
import BrokersPartners from "@/pages/BrokersPartners";
import SubmitProperty from "@/pages/SubmitProperty";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AuthProvider, useAuth } from "@/lib/auth";

function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-cream text-forest">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/what-we-buy" element={<WhatWeBuy />} />
            <Route path="/development" element={<Development />} />
            <Route path="/investment-opportunities" element={<InvestmentOpportunities />} />
            <Route path="/brokers-partners" element={<BrokersPartners />} />
            <Route path="/submit-property" element={<SubmitProperty />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Legal kind="privacy" />} />
            <Route path="/terms-of-use" element={<Legal kind="terms" />} />
            <Route path="/investment-disclaimer" element={<Legal kind="disclaimer" />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
